module.exports = __webpack_public_path__ + "salesforce_logo.70437a2aa0a3bfc40ffc28f30ef512c1.png";